import topicStatusWithButton from './topic-status-with-button/index.json';
import scrolltoTop from './scroll-to-top/index.json';

const components = {
    topicStatusWithButton,
    scrolltoTop,
};

export default components;
